// components/ArticleList.tsx
import React, { useEffect } from 'react';
import { TFunction } from 'next-i18next';
import Texto from '@/components/elements/Texto';
import { textosPeque } from '@/constants/Dimens';
import { Rating } from '@mui/material';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import { GetPuntuacion, Puntuacion } from '@/objects/Puntuacion';

interface ArticleListProps {
  id_usuario: number,
  t: TFunction;
}

//Son 5 estrellas y los puntos son del 0 al 10
const PRECISION = 0.5;

const ComponentePuntuacion: React.FC<ArticleListProps> = ({ id_usuario, t }) => {

  const { usersQueries } = useServices();


  const [puntuacion, setPuntuacion] = React.useState<number>(0);
  const [numero_comentarios, setNumeroComentarios] = React.useState<number>(0);
  const [puntuacionObj, setPuntuacionObj] = React.useState<Puntuacion[]>();

  useEffect(() => {
    if(id_usuario == null || !Number.isFinite(id_usuario) || id_usuario <= 0) {
      return;
    }
    usersQueries?.obtenerPuntuacion(id_usuario).then((response: AxiosResponse<Puntuacion[]>) => {
      //console.log('Artículos:', response.data);
      const puntuacion: Puntuacion[] = response.data;
      setPuntuacionObj(puntuacion);
      setNumeroComentarios(puntuacion.length);
      let suma = 0;
      puntuacion.forEach((puntuacion) => {
        suma += puntuacion.puntos;
      });
      setPuntuacion((suma / puntuacion.length) * PRECISION);
      //alert('Puntuación:' + suma / puntuacion.length);
    }).catch((error) => {
      //alert('Error al obtener artículos:' + error);
    });
  }, [id_usuario])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center' }}>
      <Rating name="half-rating-read" defaultValue={puntuacion} value={puntuacion} precision={PRECISION} size="small" readOnly />
      <Texto fontSize={textosPeque}>{t("contenido:user.card_user.comentarios") + " (" + numero_comentarios + ")"}</Texto>
    </div>
  );
}

export default ComponentePuntuacion;


